import React from 'react';

interface ProgressBarProps {
  filled: number;
  total: number;
  status: 'new' | 'filled' | 'rejected' | 'partially_filled' | 'cancelled';
}

export default function ProgressBar({ filled, total, status }: ProgressBarProps) {
  const percentage = total > 0 ? Math.min(100, Math.max(0, (filled / total) * 100)) : 0;
  
  const statusColors: Record<string, string> = {
    'new': '#4da3ff',
    'partially_filled': '#ff8c3a',
    'filled': '#36c98e',
    'rejected': '#ff5c5c'
  };
  
  const color = statusColors[status] || '#7e8a96';
  
  return (
    <div style={{ 
      width: '100%', 
      height: 6, 
      // The track was #10151b -- identical to the panel behind it, so an unfilled bar was
      // invisible and a 0%-filled order looked like no bar at all. This reads as a groove.
      backgroundColor: '#1c242e',
      border: '1px solid #2a3540',
      boxSizing: 'border-box',
      
      borderRadius: 3,
      overflow: 'hidden',
      position: 'relative'
    }}>
      <div
        style={{
          width: `${percentage}%`,
          height: '100%',
          backgroundColor: color,
          transition: 'width 0.3s ease',
          borderRadius: 3
        }}
      />
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: 9,
        color: '#7e8a96',
        fontWeight: 600,
        textShadow: '0 0 2px rgba(0,0,0,0.8)'
      }}>
        {percentage.toFixed(0)}%
      </div>
    </div>
  );
}

